module.exports = __webpack_public_path__ + "img/system47-details.328a9d74.png";